import { createClient } from 'contentful'

const spaceId = process.env.VUE_APP_CONTENTFUL_SPACE_ID
const accessToken = process.env.VUE_APP_CONTENTFUL_ACCESS_TOKEN

if (!spaceId || !accessToken) {
    console.error('Contentful environment variables are missing')
    console.error('Please check that your .env file exists and has the required variables:')
    console.error('VUE_APP_CONTENTFUL_SPACE_ID')
    console.error('VUE_APP_CONTENTFUL_ACCESS_TOKEN')
}

export const contentfulClient = createClient({
    space: spaceId,
    accessToken: accessToken,
}) 